import { useMutation } from "@tanstack/react-query";
import { axios } from "@/client/libs/axios";
import { WithdrawalWithUser } from "libs/dto/src/withdrawal";
import { queryClient } from "@/client/libs/query-client";

const RequestWithdrawal = async (data: { amount: number }) => {
  const response = await axios.post<WithdrawalWithUser>("/withdrawals", data);
  return response.data;
};

export const useRequestWithdrawal = () => {
  const {
    error,
    isPending: loading,
    mutateAsync: RequestWithdrawalFn,
  } = useMutation({
    mutationFn: RequestWithdrawal,
    onSuccess: (data) => {
      queryClient.setQueryData<WithdrawalWithUser>(["withdrawal", { id: data.id }], data);
    },
  });
  return { RequestWithdrawal: RequestWithdrawalFn, loading, error };
};
